module.exports = __webpack_public_path__ + "img/location.b19f3360.svg";